<template>
    <div class="user-details">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'usersDetails' }, id );">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            View User Details
                        </div>
                    </div>
                </div>
            </div>

            <hr />
        </div>
        <div class="container">

            <div class="mt-5">
                <ul class="nav custom-tab">
                    <div class="nav-link pointer" @click="showPersonalDetail" :class="{ active: showPersonalStatus }">Personal Details</div>
                    <div class="nav-link pointer" v-if="canModify" @click="showPayrollDetail" :class="{ active: showPayrollStatus }">Payroll Details</div>
                </ul>
            </div>
            
            <div class="reference-card">
                <form @submit.prevent="checkForm" action="" method="post" class="readonly-form">
                    <transition name="fade" mode="out-in">
                        <div v-if="showPersonalStatus">
                            <div class="row" v-if="userData.profile_image">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">User Photo</label>
                                        <div class="image-holder">
                                            <img :src="baseUrl + userData.profile_image" alt=""> 
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="name">Name</label> 
                                        <input v-model="userData.name" class="form-control" type="text" name="name" id="name" disabled>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Birth Date</label>
                                        <input class="form-control" v-model="userData.date_of_birth" type="text" name="date_of_birth" id="date_of_birth" disabled>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Gender</label>
                                        <input v-if="userData.gender" v-model="userData.gender.value" class="form-control" type="text" name="name" id="gender" disabled>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="email">Email</label>
                                        <input class="form-control" v-model="userData.email" type="email" name="email" id="email" disabled>

                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="phone">Phone</label>
                                        <input class="form-control" v-model="userData.phone" type="tel" name="phone" id="phone" disabled>

                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="marital_status">Marital Status</label>
                                        <input class="form-control" v-if="userData.marital_status" v-model="userData.marital_status.value" type="text" name="marital_status" id="marital_status" disabled>
                                        <input class="form-control" v-if="!userData.marital_status" value="-" type="text" name="marital_status" id="marital_status" disabled>
                                    </div>
                                </div>
                            </div>

                            <hr>

                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group mb-3">
                                        <label for="nric">IC No.</label>
                                        <input class="form-control" v-model="userData.nric" type="text" name="nric" id="nric" disabled>
                                    </div>
                                    <div class="form-group" v-if="userData.nric_image">
                                        <label for="">IC Photo</label>
                                        <div class="image-holder">
                                            <img :src="baseUrl + userData.nric_image" alt=""> 
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-3">
                                    <div class="form-group mb-3">
                                        <label for="kartu_keluarga">Kartu Keluarga</label>
                                        <input class="form-control" v-model="userData.kartu_keluarga" type="text" name="kartu_keluarga" id="kartu_keluarga" disabled>
                                    </div>
                                    <div class="form-group" v-if="userData.kartu_keluarga_image">
                                        <label for="">Kartu Keluarga Photo</label>
                                        <div class="image-holder">
                                            <img :src="baseUrl + userData.kartu_keluarga_image" alt=""> 
                                        </div>
                                    </div>
                                </div> -->
                                <!-- <div class="col-md-3">
                                    <div class="form-group mb-3">
                                        <label for="tax_id">NPWP</label> 
                                        <input class="form-control" v-model="userData.npwp" type="text" name="tax_id" id="tax_id" disabled>
                                    </div>
                                    <div class="form-group" v-if="userData.tax_image">
                                        <label for="">NPWP Photo</label>
                                        <div class="image-holder">
                                            <img :src="baseUrl + userData.tax_image" alt=""> 
                                        </div>
                                    </div>
                                </div> -->
                            </div>

                            <hr>


                            <div class="form-group">
                                <label for="address">Address</label> 
                                <textarea class="form-control" v-model="userData.address" rows="2" name="address" id="address" disabled></textarea>
                            </div>

                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Division</label>

                                        <input class="form-control" v-if="userData.division" v-model="userData.division.value" type="text" name="division" id="division" disabled>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Region</label>

                                        <input class="form-control" v-if="userData.region" v-model="userData.region.name" type="text" name="region_id" id="region_id" disabled>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Primary Area</label>

                                        <input class="form-control" v-if="userData.area" v-model="userData.area.name" type="text" name="area_id" id="area_id" disabled>
                                    </div>
                                </div>
                            </div>

                            <hr>

                            <div class="row" v-if="userData.bank_acc_image">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Photo of Bank book / card (Personal)</label>
                                        <div class="image-holder">
                                            <img :src="baseUrl + userData.bank_acc_image" alt=""> 
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="">Bank Name</label> 
                                        <input class="form-control" v-if="userData.bank_id" v-model="userData.bank_id.name" type="text" name="bank_id" id="bank_id" disabled>
                                        <input class="form-control" v-if="!userData.bank_id" value="-" type="text" name="bank_id" id="bank_id" disabled>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="bank_beneficiary_name">Bank Beneficiary Name</label> 
                                        <input class="form-control" v-model="userData.bank_beneficiary_name" type="text" name="bank_beneficiary_name" id="bank_beneficiary_name" disabled>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="bank_branch">Bank Branch</label> 
                                        <input class="form-control" v-model="userData.bank_branch" type="text" name="bank_branch" id="bank_branch" disabled>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="">Bank Account Number</label> 
                                        <input class="form-control" v-model="userData.bank_acc_no" type="text" name="bank_acc_no" id="bank_acc_no" disabled>
                                    </div>
                                </div>
                            </div>

                            <hr>
                            
                            <div class="form-group">
                                <label for="">Remarks</label>
                                <textarea v-model="userData.remarks" name="remarks" id="remarks" cols="30" rows="3" class="form-control" disabled></textarea>
                            </div>
                            
                        </div>
                    </transition>
                    <transition name="fade" mode="out-in">
                        <div v-if="showPayrollStatus">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="">Grade</label>
                                        <input class="form-control" v-if="userData.grade" v-model="userData.grade" type="text" name="grade" id="grade" disabled>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="gross_salary">Gross Salary Perday</label>
                                        <input class="form-control" v-model="userData.gross_salary" type="text" name="gross_salary" id="gross_salary" disabled>
                                    </div>
                                </div>
                            </div>

                            <hr>

                            <div class="row" v-if="userData.bank_acc_image_payroll">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Photo of Bank book / card (Office)</label>
                                        <div class="image-holder">
                                            <img  :src="baseUrl + userData.bank_acc_image_payroll" alt=""> 
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="">Bank Name</label> 
                                        <input class="form-control" v-if="userData.bank_id_payroll" v-model="userData.bank_id_payroll.name" type="tel" name="bank_id_payroll" id="bank_id_payroll" disabled>
                                        <input class="form-control" v-if="!userData.bank_id_payroll" value="-" type="tel" name="bank_id_payroll" id="bank_id_payroll" disabled>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="bank_beneficiary_name">Bank Beneficiary Name</label> 
                                        <input class="form-control" v-model="userData.bank_beneficiary_name_payroll" type="text" name="bank_beneficiary_name" id="bank_beneficiary_name" disabled>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="bank_branch">Bank Branch</label> 
                                        <input class="form-control" v-model="userData.bank_branch_payroll" type="text" name="bank_branch" id="bank_branch" disabled>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="">Bank Account Number</label> 
                                        <input class="form-control" v-model="userData.bank_acc_no_payroll" type="text" name="bank_acc_no" id="bank_acc_no" disabled>
                                    </div>
                                </div>
                            </div>
                            
                            <hr>  

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="">Employment Status</label> 
                                        <input class="form-control" v-if="userData.user_status" v-model="userData.user_status.value" type="text" name="user_status" id="user_status" disabled>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="">User Type</label> 
                                        <input class="form-control" v-if="userData.user_type" v-model="userData.user_type.value" type="text" name="user_type" id="user_type" disabled>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="staff_id">Staff Id</label>
                                        <input class="form-control" v-model="userData.staff_id" type="text" name="staff_id" id="staff_id" disabled>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="">Position</label>
                                        <input class="form-control" v-if="userData.position" v-model="userData.position.name" type="text" name="position_id" id="position_id" disabled>
                                    </div>
                                </div>
                            </div>

                           <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Join Date</label>
                                        <input class="form-control" v-model="userData.join_date" type="text" name="join_date" id="join_date" disabled>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="">Resign Date</label>
                                        <input class="form-control" v-model="userData.resign_date" type="text" name="resign_date" id="resign_date" disabled>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </form>
            </div>

            <button @click="edit()" type="button" class="mt-2 btn btn-ecdc btn-shadow">Edit</button>
        </div>
        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { checkPermission, getUserDetail } from '../api'
import Loader from './Loader.vue'

export default {
    components: {
        appLoader: Loader,
    },
    data() {
        return {
            userData: "",
            defaultAreaId: 0,
            isLoading: true,
            id: 0,
            showPersonalStatus:true,
            showPayrollStatus:false,
            canModify: false,
            baseUrl: process.env.VUE_APP_IMAGE_BASE_URL
        }
    },
    async mounted() {
        this.id = this.$route.params.id;
        await this.getUserDetail();
        this.canModify = await this.checkModifyPermission('modify payroll');

        this.isLoading = false;
    },
    methods: {
        async getUserDetail() {

            try {

                const result = await getUserDetail(this.id);
                this.userData = result.data.data;
                this.userData.name = this.userData.name || "-";
                this.userData.gender = this.userData.gender || "-";
                this.userData.email = this.userData.email || "-";
                this.userData.phone = this.userData.phone || "-";
                this.userData.nric = this.userData.nric || "-";
                this.userData.date_of_birth = this.userData.date_of_birth || "-";

                if(this.userData.marital_status)
                    this.userData.marital_status.value = this.userData.marital_status.value || "-";

                this.userData.kartu_keluarga = this.userData.kartu_keluarga || "-";
                this.userData.address = this.userData.address || "-";
                this.userData.division = this.userData.division || "-";
                this.userData.region = this.userData.region || "-";
                this.userData.area = this.userData.area || "-";

                if(this.userData.bank_id)
                    this.userData.bank_id.name = this.userData.bank_id.name || "-";

                this.userData.bank_beneficiary_name = this.userData.bank_beneficiary_name || "-";
                this.userData.bank_branch = this.userData.bank_branch || "-";
                this.userData.bank_acc_no = this.userData.bank_acc_no || "-";
                this.userData.npwp = this.userData.npwp || "-";
                this.userData.remarks = this.userData.remarks || "-";
                this.userData.grade = this.userData.grade || "-";
                this.userData.gross_salary = this.userData.gross_salary || "-";

                if(this.userData.bank_id_payroll)
                    this.userData.bank_id_payroll.name = this.userData.bank_id_payroll.name || "-";

                this.userData.bank_beneficiary_name_payroll = this.userData.bank_beneficiary_name_payroll || "-";
                this.userData.bank_branch_payroll = this.userData.bank_branch_payroll || "-";
                this.userData.bank_acc_no_payroll = this.userData.bank_acc_no_payroll || "-";
                this.userData.user_status = this.userData.user_status || "-";
                this.userData.user_type = this.userData.user_type || "-";
                this.userData.staff_id = this.userData.staff_id || "-";
                this.userData.position = this.userData.position || "-";
                this.userData.join_date = this.userData.join_date || "-";
                this.userData.resign_date = this.userData.resign_date || "-";
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        edit() {

            this.$router.push({ name: "userEdit" }, this.id);
        },
        showPersonalDetail() {
            this.showPersonalStatus = true;
            this.showPayrollStatus = false;
        },
        showPayrollDetail() {
            this.showPersonalStatus = false;
            this.showPayrollStatus = true;
        },
        async checkModifyPermission(permission) {

            try {
                const result = await checkPermission({permission:permission});
                return result.data.data;
            }
            catch(err) {
                return false;
            }
        }
    }
}
</script>